<template>
  <div>
    <ProductIndexMobile
      v-if="isMobile"
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
    />
    <ProductIndexDesktop
      v-else
      :other-links="$options.otherLinks"
      :page-description="$options.pageDescription"
      :breadcrumb-links="$options.breadcrumbLinks"
    />
  </div>
</template>

<script>
import {
  generateOtherLinks,
  getMutualFundProductObject,
  generateBreadcrumbLinks,
  seoMapperConstant as CONSTANT,
} from 'shared/helpers/seoMap';
import isMobile from 'shared/mixins/isMobile';
import ProductIndexMobile from '../../components/mobile/product/ProductIndex';
import ProductIndexDesktop from '../../components/desktop/product/ProductIndex';

const mutualFundProductObject = getMutualFundProductObject();

export default {
  name: 'ProductIndexPage',
  metaInfo() {
    return {
      title: mutualFundProductObject.meta_title,
      meta: [
        { name: 'description', content: mutualFundProductObject.meta_desc },
        { name: 'keyword', content: mutualFundProductObject.meta_keyword },
      ],
    };
  },
  components: {
    ProductIndexMobile,
    ProductIndexDesktop,
  },
  mixins: [isMobile],
  otherLinks: generateOtherLinks(CONSTANT.PRODUCT_KEY),
  pageDescription: mutualFundProductObject.page_desc,
  breadcrumbLinks: generateBreadcrumbLinks(CONSTANT.PRODUCT_KEY),
};
</script>
